module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-time-picker', _vm._g(_vm._b({
    attrs: {
      "format": _vm.item.valueFormat,
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间"
    }
  }, 'el-time-picker', _vm.$attrs, false), _vm.$listeners))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-632388d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/TimeRangeWidget.vue
// module id = 721
// module chunks = 20